import { render } from "./template.vue?vue&type=template&id=0b552d78&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=0b552d78&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b552d78"]])

export default __exports__